import { Radio, RadioGroup } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const StyledRadioGroup = styled(RadioGroup)`
    & > div > label:nth-of-type(2) {
        justify-content: center;
    }
    & > div > label:nth-of-type(3) {
        justify-content: flex-end;
    }
`;

export const StyledRadio = styled(Radio)`
    border: 1px solid black;

    &[data-checked] {
        color: ${({ theme }) => theme.COLOR.pink[200]};
        border: 1px solid ${({ theme }) => theme.COLOR.pink[200]};
        background-color: #fff;
        ::hover {
            color: white;
            border: 1px solid black;
            background-color: #fff;
        }
    }
`;
